import axios from 'axios';

const TOKEN_KEY = 'adminToken';
const ROLE_KEY = 'adminRole';
const NAME_KEY = 'adminName';

function safeStorage() {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return null;
    return window.localStorage;
  } catch {
    return null;
  }
}

function safeGet(key, fallback = '') {
  try {
    const storage = safeStorage();
    if (!storage) return fallback;
    return storage.getItem(key) ?? fallback;
  } catch {
    return fallback;
  }
}

function safeSet(key, value) {
  try {
    const storage = safeStorage();
    if (!storage) return;
    storage.setItem(key, value);
  } catch {}
}

function safeRemove(key) {
  try {
    const storage = safeStorage();
    if (!storage) return;
    storage.removeItem(key);
  } catch {}
}

export function getAdminToken() {
  return safeGet(TOKEN_KEY, '');
}

export function getAdminRole() {
  return safeGet(ROLE_KEY, 'AGENT');
}

export function getAdminName() {
  return safeGet(NAME_KEY, '');
}

export function isAdminAuthenticated() {
  return !!getAdminToken();
}

export function getAdminAuthHeader() {
  return { headers: { Authorization: `Bearer ${getAdminToken()}` } };
}

export async function loginAdmin(email, password) {
  const response = await axios.post('/api/auth/login', { email, password });
  const data = response.data || {};

  if (!data.token) {
    throw new Error(data.message || 'Connexion impossible.');
  }

  const fullName = `${data.firstName || ''} ${data.lastName || ''}`.trim();

  safeSet(TOKEN_KEY, data.token);
  safeSet(ROLE_KEY, data.role || 'AGENT');
  safeSet(NAME_KEY, fullName || 'Collaborateur');

  return data;
}

export function logoutAdmin() {
  safeRemove(TOKEN_KEY);
  safeRemove(ROLE_KEY);
  safeRemove(NAME_KEY);
}


export function handleAdminAuthFailure(error) {
  const status = error?.response?.status;
  if (status === 401) {
    try { localStorage.removeItem('adminToken'); } catch (_) {}
    if (typeof window !== 'undefined' && window.location.pathname.startsWith('/admin')) {
      window.location.href = '/admin/login';
    }
  }
  return Promise.reject(error);
}


if (typeof window !== 'undefined') {
  axios.interceptors.response.use(
    (response) => response,
    (error) => handleAdminAuthFailure(error)
  );
}
